// این plugin هم سمت سرور و هم کلاینت اجرا میشه و قبل از i18n هست
export default defineNuxtPlugin({
  name: 'referral',
  enforce: 'pre', // قبل از بقیه plugin ها اجرا بشه
  setup() {
    const route = useRoute();
    
    const referral = route.query?.referal;
    if (!referral) return;

    // ذخیره در cookie
    const referralCookie = useCookie('referral', {
      maxAge: 60 * 60 * 24 * 1, // 1 day
      sameSite: 'lax',
    });

    referralCookie.value = String(referral);
  }
});
